import { render, staticRenderFns } from "./ChangeApprovalPWView.vue?vue&type=template&id=288ce505"
import script from "./ChangeApprovalPWView.ts?vue&type=script&lang=ts&external"
export * from "./ChangeApprovalPWView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports